import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/button';
import BreakTypeIcon, { BreakTypeInfo } from './BreakTypeIcon';
import {
  BTN_SM_ROUNDED_CIRCLE_BOX,
  roundSmCircleIconButtonStyle,
} from './roundSmCircleIconButtonStyle';

type Props = {
  breakTypes?: BreakTypeInfo[];
  onPause: (breakTypeId?: string) => void;
  loading: boolean;
  rounded?: boolean;
};

const BreakTypeButtons: React.FC<React.PropsWithChildren<Props>> = ({
  breakTypes,
  onPause,
  loading,
  rounded,
}) => {
  const { t } = useTranslation();
  const roundedClass = rounded ? ' btn-rounded-circle' : '';

  if (breakTypes && breakTypes.length > 1) {
    const widgetHeaderEmojiChrome: React.CSSProperties = {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'var(--bs-warning)',
      boxShadow:
        'inset 0 1px 0 rgba(255, 255, 255, 0.45), 0 1px 3px rgba(0, 0, 0, 0.15)',
    };

    const listRowEmojiStyle: React.CSSProperties = {
      ...roundSmCircleIconButtonStyle,
      backgroundColor: '#f8f9fa',
    };
    const emojiButtonStyle: React.CSSProperties = rounded
      ? {
          ...widgetHeaderEmojiChrome,
          width: BTN_SM_ROUNDED_CIRCLE_BOX,
          height: BTN_SM_ROUNDED_CIRCLE_BOX,
          paddingTop: 0,
          paddingBottom: 0,
          boxSizing: 'border-box',
        }
      : listRowEmojiStyle;

    return (
      <>
        {breakTypes.map((breakType) => (
          <Button
            key={breakType.Id}
            size="sm"
            variant="outline-warning"
            className={`me-2 lift${roundedClass} d-inline-flex align-items-center justify-content-center`}
            style={emojiButtonStyle}
            onClick={() => onPause(breakType.Id)}
            isProcessing={loading}
            tooltip={t(
              'timeTracking.current.steps.working.startBreakType.tooltip',
              { name: breakType.Name },
            )}>
            <BreakTypeIcon
              icon={breakType.flair__Icon__c}
              customEmoji={breakType.flair__Custom_Emoji__c}
              name={breakType.Name}
              size={rounded ? 14 : 16}
            />
          </Button>
        ))}
      </>
    );
  }

  return (
    <Button
      size="sm"
      variant="outline-warning"
      className={`me-2 lift${roundedClass} d-inline-flex align-items-center justify-content-center`}
      style={roundSmCircleIconButtonStyle}
      onClick={() => onPause(breakTypes?.[0]?.Id)}
      icon="pause-outline"
      isProcessing={loading}
      tooltip={t('timeTracking.current.steps.working.startBreak.tooltip')}
    />
  );
};

export default BreakTypeButtons;
